import { render } from "./CardUPINCXilema.vue?vue&type=template&id=0c0373b0&scoped=true"
import script from "./CardUPINCXilema.vue?vue&type=script&lang=js"
export * from "./CardUPINCXilema.vue?vue&type=script&lang=js"

import "./CardUPINCXilema.vue?vue&type=style&index=0&id=0c0373b0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c0373b0"]])

export default __exports__